import { render, staticRenderFns } from "./currencies-select.vue?vue&type=template&id=65d44444&"
import script from "./currencies-select.vue?vue&type=script&lang=js&"
export * from "./currencies-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports